module.exports = __webpack_public_path__ + "img/icono-GSEncuestas.36fc5528.jpg";